import React from "react";
// import panthiLogo from '../assets/images/Panthi-logo.jpeg';
import panthiLogo from "../assets/images/Panthi_logo_trans.png";
import "./Logo.css";

const Logo = ({ size = "large" }) => {
  return (
    <div className={`logo-container logo-container-img ${size}`}>
      <img src={panthiLogo} alt="Panthi Events" className="logo-img" />
    </div>
  );
};

export default Logo;
